<template>
	<div class="chat-textarea">
		<textarea @blur="blur" :value="value" :placeholder="placeholder" @focus="$emit('focus', $event.target.value)" @input="$emit('input', $event.target.value)"></textarea>
	</div>
</template>

<script>
	export default {
		name: 'chat-textarea',
		props: {
			value : {
				type : [String,Number],
				default : ''
			},
			placeholder: {
				type: String,
				default: '请输入文字'
			}
		},
        methods: {
			blur() {
				if (navigator.userAgent.toLocaleLowerCase().includes('iphone')) {
					window.scroll(0, 0);
				}
				this.$emit('blur', event.target.value);
			}
        }
	}
</script>

<style scoped lang="less">
	.chat-textarea, .chat-textarea textarea{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.chat-textarea textarea, .chat-textarea textarea::after, .chat-textarea textarea:focus{
		border: none;
		outline: none;
	}
    /* 这是针对缺省样式 (必须的) */
	.chat-textarea textarea::-webkit-scrollbar {
		width: 3px;
	}
    /* 滚动条的滑轨背景颜色 */
	.chat-textarea textarea::-webkit-scrollbar-track {
		background-color: rgba(189, 189, 189, 0.5);
	}
    /* 滑块颜色 */
	.chat-textarea textarea::-webkit-scrollbar-thumb {
		background-color: rgba(189, 189, 189, 1);
	}
    /* 滑轨两头的监听按钮颜色 */
	.chat-textarea textarea::-webkit-scrollbar-button {
		background-color: rgba(180, 180, 180, 1);
	}
    /* 横向滚动条和纵向滚动条相交处尖角的颜色 */
	.chat-textarea textarea::-webkit-scrollbar-corner {
		background-color: rgba(180, 180, 180, 1);
	}
</style>